import {EventBus} from "../../../common/ts/events/EventBus";
import {PageLoadedEvent, WhitelabelEvent} from "../../../common/ts/events/Events";
import {connect} from "../../../common/ts/connect";
import dom from "../../../common/ts/core/dom";
import {Autocomplete} from "../../../common/ts/core/autocomplete/Autocomplete";
import {setInteractionFlag} from "./SerpInteraction";

EventBus.getInstance().subscribeWithId(
    PageLoadedEvent.TYPE,
    {
        id: 'nestoria-serp-toolbar-loaded-subscriber',
        callback: onSerpToolbarLoad
    }
);

function onSerpToolbarLoad(event: WhitelabelEvent): void {
    connect(() => {
        dom.init()
        new Toolbar()
    })
}

class Toolbar {

    private readonly form: HTMLFormElement;

    constructor() {
        this.form = document.getElementById("geo-filter-form") as HTMLFormElement;
        new Autocomplete().register(this.submit.bind(this), false);
    }

    private submit() {
        setInteractionFlag('search');
        this.form.submit();
    }
}